import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogApprovalsEquipmentsApproveComponent } from './../dialog-approvals-approve/dialog-approvals-approve.component';
import { DialogApprovalsEquipmentsRejectComponent } from './../dialog-approvals-reject/dialog-approvals-reject.component';
var DialogApprovalsEquipmentsComponent = /** @class */ (function () {
    function DialogApprovalsEquipmentsComponent(approval, matDialog, matDialogRef) {
        this.approval = approval;
        this.matDialog = matDialog;
        this.matDialogRef = matDialogRef;
        this.disableButton = false;
        this.statusApproval = this.approval.status;
    }
    DialogApprovalsEquipmentsComponent.prototype.disableButtonApproval = function (isExistingNumber) {
        this.disableButton = isExistingNumber;
    };
    DialogApprovalsEquipmentsComponent.prototype.openApproveDialog = function () {
        var _this = this;
        var equipmentsApprove = this.matDialog.open(DialogApprovalsEquipmentsApproveComponent, { panelClass: ['dialog-approvals-approve'], data: this.approval });
        equipmentsApprove.afterClosed().subscribe(function (reload) {
            if (reload) {
                _this.matDialogRef.close(true);
            }
        });
    };
    DialogApprovalsEquipmentsComponent.prototype.openRejectDialog = function () {
        var _this = this;
        var equipmentsReject = this.matDialog.open(DialogApprovalsEquipmentsRejectComponent, { panelClass: ['dialog-approvals-reject'], data: this.approval });
        equipmentsReject.afterClosed().subscribe(function (reload) {
            if (reload) {
                _this.matDialogRef.close(true);
            }
        });
    };
    return DialogApprovalsEquipmentsComponent;
}());
export { DialogApprovalsEquipmentsComponent };
